module.exports = __webpack_public_path__ + "img/camioneta.728abea3.png";